import styled from '@emotion/styled'

export const StyleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100dvh;
  width: 100%;
  form {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
  }
  @keyframes zoomInOut {
    0%,
    100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.3);
    }
  }
`

export const StyleCard = styled.div`
  width: 400px;
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 8px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;

  @media (max-width: 767px) {
    width: 100%;
  }
`
